import React, { useState } from 'react';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import { RiFileExcel2Line, RiDownload2Line, RiInformationLine, RiCheckLine } from 'react-icons/ri';
import { useCreatePlanComptableMutation } from 'actions/plan_comptable/mutations';
import GeneriqueModal from 'components/GeneriqueModal';
import ButtonCancel from 'components/buttons/ButtonCancel';
import ButtonGreen from 'components/buttons/ButtonGreen';

const ModalImporterPlanComptable = ({ isOpen, onClose, dossier_id, onSuccess }) => {
  const [createPlan, { isLoading }] = useCreatePlanComptableMutation();
  const [selectedFile, setSelectedFile] = useState(null);
  const [form, setForm] = useState({
    intitule: 'Plan comptable SYSCOHADA',
    plageClients: '4111-4198',
    plageFournisseurs: '4011-4098',
    plageSalaries: '4211-4287',
  });

  // Téléchargement du modèle Excel type
  const handleDownloadTemplate = () => {
    try {
      const templateData = [
        { "Numéro de compte": 101, "Intitulé du compte": "Capital social", "Classe": "1 - Capitaux" },
        { "Numéro de compte": 162, "Intitulé du compte": "Emprunts auprès des établissements de crédit", "Classe": "1 - Capitaux" },
        { "Numéro de compte": 215100, "Intitulé du compte": "Matériel et outillage industriel", "Classe": "2 - Immobilisations" },
        { "Numéro de compte": 2815, "Intitulé du compte": "Amortissement matériel et outillage", "Classe": "2 - Immobilisations" },
        { "Numéro de compte": 401100, "Intitulé du compte": "Fournisseurs ordinaires", "Classe": "4 - Tiers" },
        { "Numéro de compte": 411100, "Intitulé du compte": "Clients ordinaires", "Classe": "4 - Tiers" },
        { "Numéro de compte": 421100, "Intitulé du compte": "Personnel - Rémunérations dues", "Classe": "4 - Tiers" },
        { "Numéro de compte": 445200, "Intitulé du compte": "État - TVA due ou collectée", "Classe": "4 - Tiers" },
        { "Numéro de compte": 521100, "Intitulé du compte": "Banque principale", "Classe": "5 - Trésorerie" },
        { "Numéro de compte": 571100, "Intitulé du compte": "Caisse principale", "Classe": "5 - Trésorerie" },
        { "Numéro de compte": 601100, "Intitulé du compte": "Achats de marchandises", "Classe": "6 - Charges" },
        { "Numéro de compte": 661100, "Intitulé du compte": "Rémunération du personnel", "Classe": "6 - Charges" },
        { "Numéro de compte": 701100, "Intitulé du compte": "Ventes de marchandises", "Classe": "7 - Produits" },
      ];

      const ws = XLSX.utils.json_to_sheet(templateData);
      ws['!cols'] = [{ wch: 20 }, { wch: 48 }, { wch: 22 }];

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Plan_Comptable");
      XLSX.writeFile(wb, "modele_plan_comptable_syscohada.xlsx");
      toast.success("Modèle Excel téléchargé avec succès !");
    } catch (err) {
      console.error("Erreur téléchargement modèle:", err);
      toast.error("Impossible de générer le modèle Excel.");
    }
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      const filename = file.name.toLowerCase();
      const validExtensions = ['.xlsx', '.xls', '.xlsm', '.xltx', '.xltm'];
      const isValid = validExtensions.some((ext) => filename.endsWith(ext));

      if (!isValid) {
        toast.error('Format non supporté. Utilisez un fichier Excel (.xlsx ou .xls).');
        return;
      }
      setSelectedFile(file);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.intitule || !form.plageClients || !form.plageFournisseurs || !form.plageSalaries) {
      toast.error('Veuillez renseigner le titre du plan et les plages de comptes.');
      return;
    }
    if (!selectedFile) {
      toast.error('Veuillez sélectionner votre fichier Excel.');
      return;
    }

    const formData = new FormData();
    formData.append('intitule', form.intitule);
    formData.append('plageClients', form.plageClients);
    formData.append('plageFournisseurs', form.plageFournisseurs);
    formData.append('plageSalaries', form.plageSalaries);
    formData.append('dossier', dossier_id);
    formData.append('dossier_id', dossier_id);
    formData.append('file', selectedFile);

    try {
      const res = await createPlan(formData).unwrap();
      toast.success(res?.message || 'Plan comptable importé avec succès !');
      if (onSuccess) onSuccess();
      handleClose();
    } catch (error) {
      const msg = error.data?.message || error.data?.error || "Erreur lors de l'import du plan comptable";
      toast.error(msg);
    }
  };

  const handleClose = () => {
    setSelectedFile(null);
    setForm({
      intitule: 'Plan comptable SYSCOHADA',
      plageClients: '4111-4198',
      plageFournisseurs: '4011-4098',
      plageSalaries: '4211-4287',
    });
    onClose();
  };

  return (
    <GeneriqueModal isOpen={isOpen} onClose={handleClose} title="Importer un plan comptable">
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        {/* ── BANNIÈRE TÉLÉCHARGER LE MODÈLE EXCEL ── */}
        <div
          className="d-flex align-items-center justify-content-between p-3 rounded-3"
          style={{
            backgroundColor: '#f0fdf4',
            border: '1px solid #bbf7d0',
            gap: '12px',
          }}
        >
          <div className="d-flex align-items-center gap-2">
            <RiFileExcel2Line size={24} style={{ color: '#16a34a', flexShrink: 0 }} />
            <div>
              <div style={{ fontWeight: 700, fontSize: '13px', color: '#15803d' }}>
                Besoin d&apos;un exemple de fichier ?
              </div>
              <div style={{ fontSize: '12px', color: '#166534' }}>
                Téléchargez notre modèle Excel officiel SYSCOHADA prêt à l&apos;emploi.
              </div>
            </div>
          </div>
          <button
            type="button"
            className="btn btn-sm btn-outline-success rounded-pill d-inline-flex align-items-center gap-1 px-3 py-1 flex-shrink-0"
            onClick={handleDownloadTemplate}
            style={{ fontSize: '12px', fontWeight: 600, backgroundColor: '#ffffff' }}
          >
            <RiDownload2Line size={14} />
            <span>Télécharger le modèle</span>
          </button>
        </div>

        <div className="form-group">
          <label className="form-label" style={{ fontWeight: 600, fontSize: '13px', color: '#0f172a' }}>
            Titre du plan <span style={{ color: '#ef4444' }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="intitule"
            placeholder="Ex: Plan SYSCOHADA"
            value={form.intitule}
            onChange={handleInputChange}
            style={{ borderRadius: '10px', fontSize: '14px' }}
          />
        </div>

        <div className="row g-2">
          <div className="col-md-4 form-group">
            <label className="form-label" style={{ fontWeight: 600, fontSize: '12px', color: '#334155' }}>
              Plage Clients <span style={{ color: '#ef4444' }}>*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name="plageClients"
              placeholder="Ex: 4111-4198"
              value={form.plageClients}
              onChange={handleInputChange}
              style={{ borderRadius: '10px', fontSize: '13px' }}
            />
          </div>

          <div className="col-md-4 form-group">
            <label className="form-label" style={{ fontWeight: 600, fontSize: '12px', color: '#334155' }}>
              Plage Fournisseurs <span style={{ color: '#ef4444' }}>*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name="plageFournisseurs"
              placeholder="Ex: 4011-4098"
              value={form.plageFournisseurs}
              onChange={handleInputChange}
              style={{ borderRadius: '10px', fontSize: '13px' }}
            />
          </div>

          <div className="col-md-4 form-group">
            <label className="form-label" style={{ fontWeight: 600, fontSize: '12px', color: '#334155' }}>
              Plage Salariés <span style={{ color: '#ef4444' }}>*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name="plageSalaries"
              placeholder="Ex: 4211-4287"
              value={form.plageSalaries}
              onChange={handleInputChange}
              style={{ borderRadius: '10px', fontSize: '13px' }}
            />
          </div>
        </div>

        <div className="form-group">
          <label className="form-label" style={{ fontWeight: 600, fontSize: '13px', color: '#0f172a' }}>
            Fichier Excel (.xlsx, .xls) <span style={{ color: '#ef4444' }}>*</span>
          </label>
          <input
            type="file"
            className="form-control"
            accept=".xlsx,.xls,.xlsm,.xltx,.xltm"
            onChange={handleFileSelect}
            style={{ borderRadius: '10px', fontSize: '13px' }}
          />
          {selectedFile && (
            <div className="text-success small mt-1 d-flex align-items-center gap-1 fw-bold">
              <RiCheckLine /> Fichier sélectionné : {selectedFile.name}
            </div>
          )}
          <small style={{ color: '#64748b', fontSize: '12px', marginTop: '4px', display: 'block' }}>
            Le fichier doit contenir au minimum une colonne pour les numéros de comptes et une colonne pour les libellés.
          </small>
        </div>

        <div
          style={{
            padding: 12,
            borderRadius: 10,
            backgroundColor: '#f8fafc',
            border: '1px solid #e2e8f0',
            fontSize: '12px',
            color: '#475569',
            lineHeight: 1.5,
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <RiInformationLine size={18} style={{ color: '#009688', flexShrink: 0 }} />
          <span>
            L&apos;import met à jour automatiquement les comptes existants et enregistre tous les nouveaux comptes dans le plan comptable du dossier.
          </span>
        </div>

        <div className="modal-footer" style={{ marginTop: 8, display: 'flex', gap: 10, justifyContent: 'flex-end', borderTop: 'none', padding: 0 }}>
          <ButtonCancel text="Annuler" onClick={handleClose} />
          <ButtonGreen
            text={isLoading ? 'Import en cours...' : 'Importer le plan'}
            type="submit"
            disabled={isLoading || !selectedFile}
          />
        </div>
      </form>
    </GeneriqueModal>
  );
};

export default ModalImporterPlanComptable;
